import { http } from '../axios';
import { shopPrefix } from '../../config';
import { SubscriptionsResponseOut } from '../../store/api';

export const fetchSubscriptions = (productId: string) => {
    return http.get<SubscriptionsResponseOut>(`${shopPrefix}/v1/subscriptions/${productId}`).then(res => res.data);
};
